import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const iconMap: Record<string, string> = {
  'ri-alert-line': 'ri-alert-line',
  'ri-star-line': 'ri-star-line',
  'ri-trophy-line': 'ri-trophy-line',
  'ri-contrast-2-line': 'ri-contrast-2-line',
  'ri-fire-line': 'ri-fire-line',
  'ri-hammer-line': 'ri-hammer-line',
};

export default function CategoryNav() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-500/40 text-primary-400 text-xs font-medium mb-4 whitespace-nowrap">
            热门分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
            爆料分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-300 max-w-xl mx-auto">
            六大核心频道，精准定位你最想吃的瓜
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={`/category/${cat.slug}`}
              onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
              className="group relative bg-background-200 border border-background-300 rounded-xl p-4 md:p-5 text-center transition-all duration-300 hover:bg-primary-500 hover:border-primary-500 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-background-300 flex items-center justify-center mx-auto mb-3 group-hover:bg-background-50/20 transition-colors">
                <i className={`${iconMap[cat.icon] || cat.icon} text-xl text-primary-400 group-hover:text-foreground-50 transition-colors`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-50 group-hover:text-foreground-50 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 mt-1 group-hover:text-foreground-100/80 transition-colors line-clamp-1">
                {cat.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}